import { IssueTypeStatusService as OvermapIssueTypeStatusService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypeStatusService extends OvermapIssueTypeStatusService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
